export const TAG_TYPE_CLASS: Record<string, string> = {
  default: "bg-[#DDDFE6] text-black",
  success: "bg-green-200 white",
  warning: "bg-warning-200 black",
  info: "bg-info black",
  waiting: "bg-waiting white",
  error: "bg-error white",
};
